import { bunja } from 'bunja';
import { atom } from 'jotai';

import { CompetitionStatusEnum } from '@flipster/apis/v2/trading-competition/types';
import { formatDatetime } from '@flipster/utils/datetime';
import Num from '@flipster/utils/num';

import { competitionApiBunja } from '../../state';
import { btcPricePrecision, pricePredictionBunja } from './state';

export const btcPriceCardBunja = bunja(() => {
  const { pricePredictionAtom, btcCurrentPriceAtom } = bunja.use(pricePredictionBunja);
  const { competitionStatusAtom } = bunja.use(competitionApiBunja);

  const isUpcomingAtom = atom((get) => get(competitionStatusAtom) === CompetitionStatusEnum.Upcoming);

  const startingPriceAtom = atom((get) => {
    const isUpcoming = get(isUpcomingAtom);
    if (isUpcoming) return null;

    const price = get(pricePredictionAtom)?.todaySnapshotPrice;
    return price ? Num(price).toFixed(btcPricePrecision) : '0';
  });

  const startingPriceDateAtom = atom((get) => {
    const prediction = get(pricePredictionAtom);
    return prediction?.pricePredictionStatus === 'ONGOING'
      ? formatDatetime(prediction?.pricePredictionStartTime, { format: "yyyy/MM/dd ('UTC+0')", isUTC: true })
      : prediction?.pricePredictionStatus === 'UPCOMING'
        ? formatDatetime(prediction?.eventStartTime, { format: "yyyy/MM/dd ('UTC+0')", isUTC: true })
        : null;
  });

  const priceInfoAtom = atom((get) => {
    const isUpcoming = get(isUpcomingAtom);
    const snapshotPrice = get(startingPriceAtom);
    const btcCurrentPrice = get(btcCurrentPriceAtom);

    if (!btcCurrentPrice) {
      return { currentPrice: '0', priceDiff: null, priceChangePercent: null, isPositive: true };
    }

    const current = Num(btcCurrentPrice);

    if (isUpcoming || !snapshotPrice || snapshotPrice === '0') {
      return { currentPrice: current.toString(), priceDiff: null, priceChangePercent: null, isPositive: true };
    }

    const snapshot = Num(snapshotPrice);
    const diff = current.minus(snapshot);
    const percentChange = snapshot.isZero() ? Num(0) : diff.div(snapshot);

    return {
      currentPrice: current.toString(),
      priceDiff: diff.toString(),
      priceChangePercent: percentChange.abs().toString(),
      isPositive: diff.gte(0),
    };
  });

  return {
    startingPriceAtom,
    startingPriceDateAtom,
    priceInfoAtom,
  };
});
btcPriceCardBunja.debugLabel = 'btcPriceCardBunja';
